
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Kolhapurtopunecab() {



    const cardData =
    {
        keyword: 'Kolhapur to Pune cab',
        heading: 'S9 Travels: Kolhapur to Pune cab',
        headingDescription: 'S9 Travels offers trusted and affordable Kolhapur to Pune cab services, perfect for business travelers, families, and leisure seekers returning from Kolhapur. The road distance is approximately 235 kilometers, covered in 4 to 5 hours via the scenic NH48 highway.',

        top: 'Top Places to Visit in Kolhapur with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a historic fort built in 1732, once the seat of the Peshwas of the Maratha Empire. It is famous for its majestic gates, intricate architecture, and rich history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Aga Khan Palace is a historic landmark where Mahatma Gandhi and his wife were imprisoned during the Quit India Movement. It now serves as a museum showcasing artifacts from India's freedom struggle."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located on a hilltop, Sinhagad Fort is known for its scenic beauty and historical significance. It was the site of an important battle in Maratha history and is a popular trekking destination."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of Pune’s most famous temples, this temple is dedicated to Lord Ganesha. The idol is adorned with gold and attracts thousands of devotees and tourists every year."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum showcases a vast collection of artifacts, including sculptures, paintings, and musical instruments, offering a glimpse into India’s cultural heritage."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, this 8th-century structure is an important archaeological site in Pune, featuring intricate carvings and a serene atmosphere."
    },
    {
      "title": "Vetal Tekdi",
      "description": "Vetal Tekdi is one of Pune’s highest points, offering panoramic views of the city. It is a favorite spot for trekkers, nature lovers, and fitness enthusiasts."
    },
    {
      "title": "Pashan Lake",
      "description": "A beautiful artificial lake, Pashan Lake is a great place for birdwatching and relaxing walks. It provides a peaceful escape from the city's hustle and bustle."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a renowned spiritual retreat offering meditation programs and wellness therapies."
    },
    {
      "title": "FC Road and JM Road",
      "description": "Fergusson College Road (FC Road) and Jangali Maharaj Road (JM Road) are popular for shopping, street food, and vibrant nightlife, attracting youngsters and tourists alike."
    }
],

"services": [
  {
    "name": "Kolhapur to Pune Cab Service",
    "description": "S9 Travels offers safe and dependable Kolhapur to Pune cab services with AC sedans, SUVs, and Innova options. Ideal for business trips, temple visits, and personal travel."
  },
  {
    "name": "Book Kolhapur to Pune Taxi Online",
    "description": "Easily book a taxi from Kolhapur to Pune online with flexible pickup times and transparent fares. Enjoy 24/7 service with professional drivers and clean, well-maintained cabs."
  },
  {
    "name": "Affordable Cab from Kolhapur to Pune",
    "description": "Get affordable Kolhapur to Pune taxi fares with no hidden charges. Our cost-effective cabs are ideal for budget-conscious travelers who don’t want to compromise on comfort."
  },
  {
    "name": "Private Taxi to Pune from Kolhapur",
    "description": "Prefer privacy on your journey? Book a private AC cab from Kolhapur to Pune — great for solo travelers, couples, or families looking for a personal and uninterrupted ride."
  },
  {
    "name": "One-Way & Round Trip Cab Kolhapur to Pune",
    "description": "Whether you need a one-way drop or a round trip back to Kolhapur, we offer flexible options tailored to your travel schedule and comfort preferences."
  },
  {
    "name": "Comfort Ride Kolhapur to Pune AC Taxi",
    "description": "Experience maximum comfort with our AC cabs from Kolhapur to Pune. Spacious interiors, smooth suspension, and courteous drivers ensure a relaxing trip."
  },
  {
    "name": "Luxury Innova Crysta Cab from Kolhapur to Pune",
    "description": "Travel in style with our luxury Innova Crysta or SUV cabs. Plush seating, chilled air conditioning, and premium service for a high-end experience on the Kolhapur to Pune route."
  },
  {
    "name": "Group Travel Cab Kolhapur to Pune",
    "description": "Planning group travel? Book a Tempo Traveller or large SUV from Kolhapur to Pune. Ample luggage space and comfortable seating for up to 7–12 passengers."
  },
  {
    "name": "Convenient Kolhapur to Pune Airport Transfer",
    "description": "Need a cab to Pune Airport from Kolhapur? Our timely airport transfer service ensures you reach your flight on time with a smooth and punctual ride."
  }
],
  "tableData": [
    ["Kolhapur to Pune Cab Service", "Book Kolhapur to Pune Taxi"],
    ["Affordable Kolhapur to Pune Cab", "Private Taxi for Pune from Kolhapur"],
    ["Kolhapur to Pune One-Way or Round Trip", "Comfortable Taxi Ride from Kolhapur to Pune"],
    ["Luxury Taxi for Pune from Kolhapur", "Group Travel to Pune from Kolhapur"],
    ["Convenient Kolhapur to Pune Trip by Taxi", "Kolhapur to Pune One-Way or Round Trip"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we ensure a timely and reliable service for your journey from Kolhapur to Pune. Our drivers are punctual and dedicated to providing you with a smooth and comfortable ride, ensuring you reach your destination on time."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the perfect vehicle for your trip from Kolhapur to Pune. With comfortable seating, air conditioning, and ample space for luggage, you can enjoy a relaxing and stress-free journey. Whether you're traveling solo or with family and friends, you’ll experience comfort throughout the ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and knowledgeable about the best routes from Kolhapur to Pune. They are courteous, professional, and focused on providing you with a smooth and hassle-free journey. You can relax and enjoy the ride with complete peace of mind."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Kolhapur to Pune ride. You’ll receive a clear breakdown of all costs upfront, with no hidden charges, allowing you to plan your travel comfortably and confidently."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova vehicles come equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring you have a safe and comfortable journey from Kolhapur to Pune."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, so you can travel from Kolhapur to Pune at any time. Whether it's an early morning or late-night ride, we will ensure your cab is ready when you need it, and our customer service team is always available to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Kolhapur to Pune cab is easy with S9 Travels. You can book online via our website or mobile app, or contact our customer service team for personalized assistance in reserving your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "If you have specific needs or would like to make additional stops during your journey, we offer customized travel packages. Whether you want a direct route or need a break along the way, we’ll tailor the trip to suit your preferences."
  }
]






    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Kolhapur to Pune with S9 Travels?',
            answer: 'Booking a cab for your Kolhapur to Pune trip is simple! You can book online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Kolhapur to Pune travel?',
            answer: 'We offer a variety of cabs, including the spacious Toyota Innova, which is perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that best suits your needs for a comfortable journey.'
          },
          {
            question: 'Are the drivers experienced for the Kolhapur to Pune route?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes from Kolhapur to Pune. They ensure a smooth, safe, and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab from Kolhapur to Pune?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and secure online payments via our mobile app for your convenience.'
          },
          {
            question: 'Can I book a round trip from Kolhapur to Pune?',
            answer: 'Yes, we offer round-trip bookings. Simply provide us with your return details, and we’ll arrange a smooth and comfortable ride back from Pune to Kolhapur.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges, such as for detours or waiting time, will be clearly communicated to you upfront, ensuring transparency in the pricing structure.'
          },
          {
            question: 'Can I make additional stops on the way from Kolhapur to Pune?',
            answer: 'Yes, you can request additional stops. Please inform us during the booking process, and we’ll accommodate your requests for stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Kolhapur to Pune trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or special requirements, please let us know when booking, and we will make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Kolhapur to Pune?',
            answer: 'Yes, we offer corporate travel services for business trips from Kolhapur to Pune, ensuring a comfortable, professional, and timely service.'
          },
          {
            question: 'Why should I choose S9 Travels for my Kolhapur to Pune cab booking?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey from Kolhapur to Pune.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghavendra K.',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I traveled from Kolhapur to Pune with S9 Travels, and it was a great experience. The driver was friendly, the vehicle was clean and spacious, and the ride was very smooth. Highly recommended for anyone traveling between these cities!”'
        },
        {
          name: 'Mrs. Shubhangi Mehta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We used S9 Travels for a trip from Kolhapur to Pune, and the service was excellent. The vehicle was comfortable and well-maintained, and the driver was very professional. I will definitely book with S9 Travels again in the future!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      

      
      
//   const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Kolhapur to Pune Cab",
//   "image": "https://www.s9travels.com/images/keyword/93.jpg", 
//   "description": "Book your Kolhapur to Pune cab with S9 Travels for a safe, affordable, and convenient journey. Enjoy one-way or round-trip travel in AC sedans, SUVs, and luxury cars. Our experienced drivers ensure timely pickups, comfortable rides, and a smooth experience from Kolhapur to Pune.",
//   "brand": {
//     "@type": "Brand",
//     "name": "S9 Travels"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.8",
//     "ratingCount": "3241"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "3899",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.s9travels.com/Kolhapur-to-Pune-Cab"
//   }
// };


     const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kolhapur to Pune Cab Service – S9 Travels",
  "image": "https://www.s9travels.com/images/keyword/93.jpg",
  "description": "Hire Kolhapur to Pune cab with S9 Travels starting at ₹3899. Choose Hatchback, Sedan, SUV & Innova Crysta for one-way or round trips. Safe and comfortable travel with professional drivers, on-time pickup, 24/7 support, and instant online booking for your Kolhapur to Pune journey.",
  "brand": {
    "@type": "Brand",
    "name": "S9 Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5928"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.s9travels.com/kolhapur-to-pune-cab"
  }
};


 


    return (
        <div>
        
        <Helmet>
  <title>Kolhapur to Pune Cab from ₹3899 | One-Way & Round Trip Taxi – S9 Travels</title>

  <meta 
    name="description" 
    content="Book Kolhapur to Pune cab with S9 Travels from ₹3899. One-way and round-trip AC Hatchback, Sedan, SUV & Innova Crysta available. Enjoy safe, comfortable, and affordable travel with professional drivers, 24/7 booking support, and instant confirmation for a smooth journey."
  />

  <meta 
    name="keywords" 
    content="Kolhapur to Pune Cab, Kolhapur to Pune Taxi Booking, One Way Kolhapur to Pune Cab, Round Trip Taxi Kolhapur Pune, Kolhapur to Pune Innova Crysta, SUV Taxi Kolhapur Pune, Affordable Taxi Kolhapur to Pune, Luxury Cab Kolhapur Pune, Online Cab Booking Kolhapur to Pune, Outstation Cabs Kolhapur Pune"
  />

  <link rel="canonical" href="https://s9travels.com/kolhapur-to-pune-cab" />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>    
    {/* <Helmet>
  <title>Kolhapur to Pune Cab Booking | S9 Travels</title>

  <meta 
    name="description" 
    content="Book Kolhapur to Pune cabs with S9 Travels. Get one-way and round-trip AC taxis, SUVs, and Innova at affordable fares. Safe travel, experienced drivers, and 24x7 booking support for hassle-free journeys." 
  />

  <meta 
    name="keywords" 
    content="Kolhapur to Pune Cab, Book Taxi from Kolhapur to Pune, One Way Kolhapur to Pune Cab, Round Trip Taxi Kolhapur Pune, Kolhapur to Pune AC Cab, S9 Travels Kolhapur Pune Cab Booking, Kolhapur to Pune Innova Taxi, SUV Cabs Kolhapur to Pune" 
  />

  <link rel="canonical" href="https://s9travels.com/kolhapur-to-pune-cab" />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}

      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/93.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kolhapurtopunecab;